import { render, staticRenderFns } from "./devBY.vue?vue&type=template&id=c0dbe016&scoped=true&"
import script from "./devBY.vue?vue&type=script&lang=js&"
export * from "./devBY.vue?vue&type=script&lang=js&"
import style0 from "./devBY.vue?vue&type=style&index=0&id=c0dbe016&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dbe016",
  null
  
)

export default component.exports